import ServiceDetail from '@/components/feature/ServiceDetail';

export default function MetaAdsPage() {
  return <ServiceDetail slug="meta-ads" />;
}